import React from "react";
import { useFormOrchestrator } from "../../FormContext/useFormContext";
import CustomCardList from "@components/PatientForms/common/CustomCardList";
import { FormField } from "@components/FormEngine/types";
import { CategoryType } from "../../../../types/PatientFormTypes";
import { z } from "zod";

const exerciseFields: FormField[] = [
  {
    type: "autocomplete",
    name: "type",
    label: "Form of Exercise",
    options: [
      "Cardio",
      "Strength",
      "Flexibility",
      "Balance",
      "Sports",
    ],
    fieldProps: {
      allowCustom: true,
      disableMargins: true,
      sx: { backgroundColor: "inherit" },
    },
    rule: z.string().min(1, "Please select an option"),
  },
	{
    type: "numeric",
    name: "frequency",
    label: "Frequency (per week)",
    fieldProps: {
      min: 0,
      max: 99,
			decimalScale: 0,
    },
    rule: z.number().min(0, "Please enter a valid frequency"),
  },
  {
    type: "select",
    name: "intensity",
    label: "Intensity",
    options: [
      "Light",
      "Moderate",
      "Intense",
    ],
    rule: z.string().min(1, "Please select an option"),
  },
	{
		type: "input",
		name: "device",
		label: "Device used to monitor activity (optional)",
		fieldProps: {
			placeholder: "e.g. Apple Watch, Fitbit, etc.",
		},
	},
  {
    type: "input",
    name: "limitations",
    label: "Does anything limit your ability to exercise? (optional)",
		fieldProps: {
			placeholder: "e.g. Pain, fatigue, etc.",
		},
	},
];

const newExercise = {
  type: null,
  frequency: null,
  intensity: null,
  device: '',
  limitations: '',
};

export const ExerciseList: React.FC = () => {
  const { saveCategoryData } = useFormOrchestrator();
  const category: CategoryType = "exerciseHistory";

  return (
    <CustomCardList
      name="exercises"
      label="Exercises"
      addButtonText="Exercise"
      cardFields={exerciseFields as any}
      category={category}
      onSaveCategoryData={saveCategoryData}
      newItemTemplate={newExercise}
    />
  );
};

export default ExerciseList;
